export default __webpack_public_path__ + "static/media/hero.1e423bc3.svg";